import FlightsSearchForm from './FlightsSearchForm';
import getFlightsSearchQueryParams from './helpers/getFlightsSearchQueryParams';
import parseRoute from './helpers/parseRoute';
import searchHistoryLocalStorage from './helpers/searchHistoryLocalStorage';
import searchUrlMap from './helpers/searchUrlMap';
import reducers from './reducers';

const { actions, heatmap, suggests } = reducers;

export {
  actions,
  heatmap,
  suggests,
  getFlightsSearchQueryParams,
  searchHistoryLocalStorage,
  searchUrlMap,
  parseRoute,
  FlightsSearchForm as form,
};
